import { Component, OnInit } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { RegionComunaDTO } from "app/main/apps/shared/interfaces/region-comuna.interface";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { finalize } from "rxjs/operators";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
@Component({
    selector: "app-factor-comunas",
    templateUrl: "./factor-comunas.component.html",
    styleUrls: ["./factor-comunas.component.scss"],
})
export class FactorComunasComponent implements OnInit {
    public regiones: RegionComunaDTO[];
    public comunas: RegionComunaDTO[];
    public procesando:boolean=false;

    constructor(
        private _codigos: CodigosService,
        private _notificacionSrvc: NotificacionesService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseProgressBarService: FuseProgressBarService,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {
        this._codigos.fetchRegiones().subscribe((resp) => {
            this.regiones = resp;
        });
    }

    buscaComunas(region: number) {
        this._codigos.fetchComunasRegion(region).subscribe((resp) => {
            this.comunas = resp;
            this._codigos.comunasChanged$.next(resp);
        });
    }

    guardarRecargo(comuna: RegionComunaDTO) {
        
        this._fuseProgressBarService.show();
        this._codigos.saveRecargoComuna(comuna)
            .pipe(finalize(()=>{
                this._fuseProgressBarService.hide(); 
                this.procesando=false;
            }))
            .subscribe((resp) => {
                this._codigos.recargarComunasChange$.next(false);
                this._notificacionSrvc.mostrarNotificacion(
                    "Recargo actualizado para la comuna de " + comuna.nombre,
                    "success"
                );
        });
    }
}
